<template>
  <div id="app">
    <img src="./assets/logo.png">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
@font-face {
  font-family: "Myriad Pro";
  src: url("./assets/myriad-pro-light.otf");
}
html {
  background-color: #313131;
}
#app {
  font-family: "Myriad Pro", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #cecece;
  margin-top: 20px;
  user-select: none;
}
img {
  width: 45%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue